import { render, staticRenderFns } from "./addresses-add-form.vue?vue&type=template&id=7b4cccdd&"
import script from "./addresses-add-form.vue?vue&type=script&lang=js&"
export * from "./addresses-add-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports